import React, { useEffect, useState } from "react";
import "../CSS/knowYourEcycle.css";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { getAllBikes } from "../Actions/bikeActions";
import { useDispatch, useSelector } from "react-redux";
import UserManual from "../Components/UserManual";
import { useNavigate } from "react-router-dom";

const bikeData = [
  {
    name: "Lil E",
    id: "2589e79c-d310-4c76-80c4-5f12afebe259",
  },
  {
    name: "X1",
    id: "4b830ba9-b60e-4384-82ab-6bc68c5fc1ad",
  },
  {
    name: "X2",
    id: "35f2bf96-eed1-4189-a490-fe26318f307f",
  },
  {
    name: "X3",
    id: "0afaf40a-45b8-4cf1-bbac-de777bd5a030",
  },
  {
    name: "T-Rex+ V3",
    id: "e23ce720-b5aa-41ba-a966-9bb2f1f6fc3d",
  },
  {
    name: "T-Rex Air",
    id: "18f3278e-cdf5-4397-909e-5a4521ab64a8",
  },
  {
    name: "Legend 07 MSD Edition",
    id: "50d6e9e7-b74f-4452-b788-f9fb7b1a7592",
  },
  {
    name: "T-Rex Pro",
    id: "929c8c6a-c456-4e12-b26c-f5f73cd9becd",
  },
  {
    name: "ST-X",
    id: "626ecf86-6197-41ce-957e-0167cbe703e4",
  },
  {
    name: "Doodle Pro",
    id: "fd81ccdc-4089-456a-9f94-2343e1c474ce",
  },
  {
    name: "G1 Cargo E-Cycle",
    id: "ee74fa27-ec59-4b18-bf9c-c9a490637a05",
  },
  {
    name: "Ranger",
    id: "5f01ca41-e602-4637-acfd-3449a72b89a7",
  },
  {
    name: "Doodle V3",
    id: "fa81a9c7-556a-441e-85eb-7dd51228cfda",
  },
  {
    name: "EMX",
    id: "4bbc6488-8e8d-42f4-a374-9cfdecab8662",
  },
  {
    name: "EMX+",
    id: "53dd105f-622a-4206-ab09-707565bd79ad",
  },
  {
    name: "Neo",
    id: "5ca5bdff-9656-496a-b035-7ae124aad171",
  },
  {
    name: "X1 Limited Edition",
    id: "c2c9f7fc-4884-40f2-8f00-77f83794eb4a",
  },
];

const customOrder = [
  "X1",
  "X2",
  "X3",
  "ST-X",
  "X1 Limited Edition",
  "Neo",
  "Legend 07 MSD Edition",
  "T-Rex Air",
  "T-Rex+ V3",
  "T-Rex Pro",
  "EMX",
  "EMX+",
  "Doodle V3",
  "Doodle Pro",
  "Ranger",
  "G1 Cargo E-Cycle",
  "Lil E",
];

const SpareScreen = () => {
  const navigate = useNavigate();
  const [selectedBike, setSelectedBike] = useState('T-Rex Air 29"');
  const handleSelectChange = (event) => {
    setSelectedBike(event.target.value);
  };
  const handleSubmit = () => {
    if (selectedBike) {
      navigate(`/spare-parts/${selectedBike}`);
    }
  };
  const dispatch = useDispatch();
  const allBikes = useSelector((state) => state.allBikes);
  const { bikes } = allBikes;
  useEffect(() => {
    if (!bikes) {
      dispatch(getAllBikes());
    }
  }, []);
  return (
    <div className="know-your-cycle-div">
      <Navbar />
      {bikes && (
        <div className="p-2 p-lg-3 position-relative">
          <picture className="main-banner-img">
            <source
              media="(max-width:650px)"
              srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/spare_mobile.jpg"
            />
            <source
              media="(min-width:651px)"
              srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/spare_desktop.jpg"
            />
            <img
              src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/spare_desktop.jpg"
              alt="Banner1"
              className="d-block w-100 rounded-4"
            />
          </picture>
          <div className="position-absolute select-menu-div-1">
            <form className="d-flex form-menu" onSubmit={handleSubmit}>
              <select
                className="form-select form-select-menu py-lg-2 w-75 w-lg-100 required"
                aria-label="Default select example"
                onChange={handleSelectChange}
              >
                <option value="" selected disabled>
                  Select product name
                </option>
                {bikes
                  .filter(
                    (bike) =>
                      bike.name !== "EMX Aqua" &&
                      bike.name !== "T-Rex+" &&
                      bike.name !== "Doodle V2"
                  )
                  .sort(
                    (a, b) =>
                      customOrder.indexOf(a.name) - customOrder.indexOf(b.name)
                  )
                  .map((bike) => (
                    <option value={bike.name}>{bike.name}</option>
                  ))}
              </select>
              <button type="submit" className="btn btn-banner px-4 px-lg-5">
                Find
              </button>
            </form>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default SpareScreen;
